export default class AbstractApiClient {

  static buildQuerystring(options: any = {}, queryOptions: string[] = []) {

    let querystring = ''
    let pairs: string[] = []

    queryOptions.forEach((optionName) => {
        let value = options[optionName]
        if (value === true || value === false) {
            value = value ? '1' : '0'
        }
        if (optionName in options) {
            pairs.push(optionName + '=' + encodeURIComponent(value))
        }
    })

    if (pairs.length > 0) {
        querystring = '?' + pairs.join('&')
    }

    return querystring

  }

}
